export default "__VITE_ASSET__e01ae765__"